import ApiCore from '../api-core'
import { PUBLIC } from '../constants'

export default class CourierTimeSheet extends ApiCore {
  constructor(store) {
    const path = `${PUBLIC}/timeSheet/courier`
    super(store, path)
  }

  templateList(filter, showProgress) {
    return this._request({
      action: 'template/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
